import { useTracking } from '@vp/react-tracking';
import React from 'react';
import {
    ModalDialog,
    ModalDialogBody,
    ModalDialogButtons,
    ModalDialogCloseButton,
    ModalDialogContent,
    ModalDialogFooter,
    ModalDialogHeader,
    ModalDialogNav,
} from '@vp/swan';
import { __ } from '@99designs/i18n';
import FeaturedCards from './FeaturedCards';
import MoreDesignCards from './MoreDesignsCards';
import SeeAllDesignsButton from './SeeAllDesignsButton';

interface DesignServicesModalProps {
    isModalOpen: boolean;
    setIsModalOpen: (_: boolean) => void;
}

export default function DesignServicesModal(props: DesignServicesModalProps) {
    const { tracking } = useTracking();

    const sendDismissAnalytics = () =>
        tracking.track('Fly-Out Closed', {
            action: 'Fly-Out Closed',
            category: 'Fly-Out',
            label: 'My Design Services:Fly-Out',
            pageSection: 'Design Services',
            pageStage: 'My Account',
            pageName: 'Design Services:Dashboard',
        });
    return (
        <ModalDialog
            isOpen={props.isModalOpen}
            onRequestDismiss={() => {
                props.setIsModalOpen(false);
                sendDismissAnalytics();
            }}
            variant="panel-right"
            bodyWidth="capped"
            textAlign="left"
        >
            <ModalDialogContent>
                <ModalDialogNav>
                    <ModalDialogCloseButton accessibleText={__('Close')} />
                </ModalDialogNav>
                <ModalDialogHeader marginBottom="5">
                    {__('What do you need designed?')}
                </ModalDialogHeader>
                <ModalDialogBody>
                    <FeaturedCards />
                    <MoreDesignCards />
                </ModalDialogBody>
                <ModalDialogFooter pinned>
                    <ModalDialogButtons>
                        <SeeAllDesignsButton />
                    </ModalDialogButtons>
                </ModalDialogFooter>
            </ModalDialogContent>
        </ModalDialog>
    );
}
